import { useMemo } from 'react';
import { GeoLocation } from 'types/locationView';
import { TideLocation } from 'types/tide';
import { Units } from 'types/units';
import { calculateDistance } from 'utils/distanceUtils';

export const useTideLocationDistance = (
  spotGeo: GeoLocation,
  tideLocation?: TideLocation,
  units?: Units,
) => {
  const { distance, distanceUnits } = useMemo(
    () =>
      calculateDistance(
        units?.tideHeight,
        spotGeo,
        tideLocation && { lat: tideLocation.lat, lon: tideLocation.lon },
      ),
    [units, spotGeo, tideLocation],
  );

  return { distanceFromSpot: distance, distanceUnits };
};

export default useTideLocationDistance;
